module.exports = __webpack_public_path__ + "img/natural-methods.8f014b50.png";